import type { CreateClientConfig } from '../generated/uis/client.gen';
import {
  createFetchWithTimeout,
  ENDPOINT_PCL_API,
  ENDPOINT_PCL_API_TIMEOUT,
} from '../utils';

export const createClientConfig: CreateClientConfig = config => ({
  ...config,
  baseUrl: ENDPOINT_PCL_API,
  fetch: createFetchWithTimeout(ENDPOINT_PCL_API_TIMEOUT),
});
